module.exports = __webpack_public_path__ + "static/media/landtrust-plus-v2.d8dc5012.webp";